import LoadingIcon from './LoadingIcon'

/**
 * Full-screen "Loading policy..." state shown when a signed-in user lands on
 * an auth route (/, /signin, /register) while bootstrap (getUser, getPolicies)
 * runs. Ensures they see the animated loading state immediately instead of
 * the generic home/sign-in page.
 */
export default function PostLoginLoadingScreen() {
  return (
    <div className="min-h-screen w-full bg-background-tertiary flex flex-col items-center justify-center">
      <LoadingIcon size="medium" message="Setting up your account..." />
    </div>
  )
}
